import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ReactComponent as NotesSvg } from './notes.svg';
import ReactHtmlParser from 'react-html-parser';
import './styles.css';

class CounselorComments extends React.Component {
  static propTypes = {
    fetchCounselorComments: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      counselorComments: '',
    };
  }

  componentDidMount() {
    const { fetchCounselorComments } = this.props;
    if (fetchCounselorComments) {
      fetchCounselorComments()
        .then(counselorData => {
          const counselorComments = counselorData.comments;
          this.setState({ counselorComments });
        })
        .catch(() => this.setState({ counselorComments: null }));
    }
  }

  render() {
    const { counselorComments } = this.state;
    return counselorComments ? (
      <div className="counselor-comments-container">
        <div className="counselor-title-container">
          <NotesSvg className="counselor-comments-svg" />
          <h2 className="counselor-comments-title">Counselor Comments</h2>
        </div>
        <div className="counselor-comments-value-container">
          <div className="counselor-comments-value">
            {ReactHtmlParser(counselorComments)}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default injectIntl(CounselorComments);
